// extracted by mini-css-extract-plugin
module.exports = {"singleCard":"styles_singleCard__1orzR","cardText":"styles_cardText__1ohKy"};